
import { defineComponent, ref, computed } from "vue";
import { useRoute } from "vue-router";
import Permission from "@/core/config/Permission";
import axios from "@/axios-instance"
import moment from "moment"
import AdminssionProceduresTab1 from "@/components/customers/AdminssionProceduresTab1.vue"
import AdmissionTicket from "@/components/customers/AdmissionTicket.vue"
import WidgetComment from "@/components/widgets/lists/WidgetComment.vue";
import SyncInfoBanner from "@/components/customers/SyncInfoBanner.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { saveAs } from 'file-saver';
import { emitter } from "@/main";
import { printUuDaiHocBong } from "@/core/helpers/printUuDaiHocBong";

interface Form {
    accidentInsuranceRegistration: null
    admissionRegistration: {
        profileCode: string,
        fullName: string,
        adCode: string,
        idAdReg: string,
        adMajorCode: string
    }
    avatar: string | null
    averageScore: number
    certificateBarcode: string | null
    certificateNumber: string | null
    collegesUniversities: string | null
    contactEmail: string
    contactMobile: string
    createdAt: string
    dateOfBirth: string
    englishClassPlacementTestRegistration: string | null
    enrolledUmt: string | null
    ethnic: string | null
    evidenceFiles: Array<any>
    familyName: string
    financialSupportRegistration: string | null
    freeTuitionRegistration: Array<any> | null
    gapTimeActivities: string | null
    gender: string
    givenName: string
    highschoolDistrict: string
    highschoolDistrictId: number
    highschoolId: number
    highschoolName: string
    highschoolProvince: string
    highschoolProvinceId: number
    id: string
    idNumber: string
    isFinancialSupport: string | null
    isSignature: string | null
    issuedBy: string | null
    issuedDate: string | null
    major: string
    middleName: string
    nationality: null
    notificationRegistration: null
    permanentAddress: string
    permanentDistrict: string
    permanentDistrictId: number
    permanentProvince: string
    permanentProvinceId: number
    permanentWard: string
    permanentWardId: number
    personalContacts: string | null
    physicalEducationSubjectRegistration: string | null
    postalAddress: string
    postalDistrict: string
    postalDistrictId: number
    postalProvince: string
    postalProvinceId: number
    postalWard: string
    postalWardId: number
    religion: string | null
    signatureDate: string | null
    socialHealthcareInsuranceRegistration: string | null
    status: string
    studentId: string
    supportServices: string | null
    tuitionRegistration: string | null
    uniformRegistration: string | null
    updatedAt: string
    yearOfGraduation: string | null
    studentCode: string | null
    username: string | null
    password: string | null
    email: string | null
    orderDetails?: any
    otherFees?: any
}
// num2Word2 (đọc số thành chữ) đã chuyển vào helper printUuDaiHocBong cùng logic in phiếu
export default defineComponent({
    name: "customer-details",
    components: {
        AdminssionProceduresTab1,
        AdmissionTicket,
        WidgetComment,
        SyncInfoBanner,
    },
    data() {
        return {
            isTabs3: false,
            avatarPreview: null as any,
            savingAvatar: false,
            programType: {
                "TIENG_VIET":"Tiếng Việt",
                "SONG_NGU":"Song Ngữ",
            }
        }
    },
    methods: {
        async printInfo(dataPrint: any,type: any) {
            // Logic in phiếu đã TÁCH ra helper printUuDaiHocBong (dùng chung với tab Hồ sơ nhập học ở chi tiết ứng viên)
            await printUuDaiHocBong(this.dataCustomer, dataPrint)
        },
        printAction() {

        },
        totalPaidLast() {
            let a = (this.total - (+this.paidBy) - Number((this.dataPreReceipt && this.dataPreReceipt.totalPreReceipt) ? this.dataPreReceipt.totalPreReceipt: 0))
            return a < 0 ? `(${Math.abs(a).toLocaleString('vi-VN')})` : a.toLocaleString('vi-VN')
        },
        // Tạo tài khoản SV THỦ CÔNG: BE dựng MSSV/email rồi gửi yêu cầu IT tạo email trên Azure.
        // Gửi 1 lần là chốt email vào hồ sơ (không tạo lại được) -> hỏi lại trước khi gửi.
        async generalEmail() {
            const confirmed = await Swal.fire({
                text: "Gửi yêu cầu IT tạo email sinh viên cho hồ sơ này? Email sẽ được ghi vào hồ sơ và không tạo lại được.",
                icon: "warning",
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: "Gửi yêu cầu",
                cancelButtonText: "Hủy",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-light",
                },
            })
            if (!confirmed.isConfirmed) return

            this.popupLoading()
            await axios.post(`applicant/generate/studentaccount`, { id: this.route.params.id })
            .then(({ data }) => {
                this.applyStudentAccount(data.applicant || data.account)
                Swal.fire({
                text: data.message,
                icon: data.status == "success"?"success":"error",
                buttonsStyling: false,
                confirmButtonText: "Đóng",
                customClass: {
                    confirmButton: "btn btn-primary",
                },
                });
            })
            .catch(({ response }) => {
                // Hiện đúng lý do BE trả về (thiếu MSSV, chưa cài mail IT, gửi mail hỏng...) thay vì câu chung chung
                Swal.fire({
                    text: response?.data?.errorMessage || response?.data?.message || "Có lỗi trong quá trình thực hiện.",
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Đóng",
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                });
                console.log('err', response)
            });
        },
        // Cập nhật khối "Tài khoản hệ thống" ở sidebar tại chỗ, khỏi reload cả trang.
        // GHI ĐÈ TỪNG FIELD, đừng gán object mới: AdmissionTicket giữ ref tới CHÍNH object này
        // (ref(props.dataInitial) lúc setup) nên thay object thì component con vẫn đọc bản cũ
        // -> banner "chưa có email" + nút In phiếu vẫn khóa cho tới khi F5.
        applyStudentAccount(account) {
            if (!account || !this.dataCustomer) return
            const fields = ['studentCode', 'username', 'email', 'password']
            fields.forEach(f => {
                if (account[f]) this.dataCustomer[f] = account[f]
            })
        },
        popupLoading() {
        Swal.fire({
            html:"<div class='custom-loading'><span>Đang xử lý. Vui lòng chờ trong giây lát!!!</span> <span class='loader'></span></div>",
            buttonsStyling: false,
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showConfirmButton: false,
        }).then(() => {
            //
        });
        },
        moment: function (date) {
            return date?moment(date).format('DD/MM/YYYY'):''
        },
        reloadData(data) {
             this.dataCustomer = {
                ...data,
            }
        },
        // Sau khi đồng bộ từ banner lệch (SyncInfoBanner) -> RELOAD để mọi nơi hiện dữ liệu vừa ghi.
        // (getData chỉ cập nhật dataCustomer; form con AdminssionProceduresTab1 giữ bản copy cũ -> nhìn như chưa đổi.)
        onSyncedDetail() {
            setTimeout(() => location.reload(), 1000)
        },
        onAvatarPick(e) {
            const file = e.target.files && e.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = () => { this.avatarPreview = reader.result as any; };
            reader.readAsDataURL(file);
        },
        async saveAvatar() {
            if (!this.avatarPreview) return;
            this.savingAvatar = true;
            await axios.put(`/applicant/avatar/${this.dataCustomer.id}`, { avatar: this.avatarPreview })
                .then(() => {
                    this.dataCustomer.avatar = this.avatarPreview;
                    this.avatarPreview = null;
                    (this.$refs.avatarModalClose as any)?.click();
                })
                .catch(({ response }) => { console.log('err', response); });
            this.savingAvatar = false;
        },
        getAvatar() {
            axios.get(`applicant/avatar/${this.dataCustomer.studentId}`,)
            .then(({ data }) => {
                this.dataCustomer.avatar = data.avatar
            })
            .catch(({ response }) => {
                console.log('err', response)
            });
        },
        async getData(id) {
            await axios.get(`applicant/${id}`)
                .then(({ data }) => {
                    this.dataCustomer = {
                        ...data,
                        createdAt: data.createdAt//moment(data.createdAt).format('DD/MM/YYYY')
                    }
                    this.getAvatar()
                    if(data?.paidBy && data?.paidBy != 'none' || true) {
                        this.getReceipt(this.dataCustomer?.id, this.dataCustomer?.studentCode as any)
                    }
                    else {
                        this.paidBy = 0
                    }
                    if (data?.status == 'cancel') {
                        this.findActiveApplicant()
                    }
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });


        },
        // Phiếu đang xem đã HỦY -> tìm phiếu ĐANG hoạt động của cùng SV (banner dẫn NV sang đúng chỗ)
        async findActiveApplicant() {
            this.activeApplicantId = null
            try {
                const { data } = await axios.get(`applicant/student/${this.dataCustomer?.studentId}`)
                const cur = (data || []).find((w: any) =>
                    w.applicantId && w.applicantId != this.dataCustomer?.id && w.applicantStatus && w.applicantStatus != 'cancel')
                this.activeApplicantId = cur ? cur.applicantId : null
            } catch (e) {
                this.activeApplicantId = null
            }
        },
        async actionSync() {
            this.popupLoading()
            let tempData = {
                studentcodes: [this.dataCustomer?.studentCode],
            }
            await axios.post(`/admission/sissync/admapplicants`,tempData)
            .then(({ data }) => {
                //BE trả {syncedCount, failedCount, messages[], errors[]} — messages thường RỖNG,
                //hiển thị theo count kẻo popup trắng; lỗi từng phần thì show chi tiết errors
                const ok = data.syncedCount ?? 0
                const fail = data.failedCount ?? 0
                Swal.fire({
                    html: `Đã đẩy <b>${ok}</b> hồ sơ qua SIS${fail ? ` · <b class="text-danger">${fail} lỗi</b>` : ''}.` +
                        (data.errors?.length ? `<div class="fs-8 text-danger mt-2 text-start">${data.errors.join('<br/>')}</div>` : ''),
                    icon: fail ? 'warning' : 'success',
                    buttonsStyling: false,
                    confirmButtonText: "Đóng",
                    customClass: { confirmButton: "btn btn-primary" },
                })
            })
            .catch(({ response }) => {
                //trước đây chỉ console.log -> loading treo, user không biết lỗi gì
                Swal.fire({
                    text: response?.data?.errorMessage || response?.data?.message || 'Đẩy hồ sơ qua SIS thất bại.',
                    icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng',
                    customClass: { confirmButton: 'btn btn-primary' },
                })
            });
        },
        actionPrinter() {
            // Điều kiện in = ĐÃ CÓ MSSV (cấp lúc xác nhận hoàn tất, hoặc cấp riêng trước đó).
            if (!this.canPrintApplicantInfo()) { return }
            // In NHANH: mở phiếu (browser render) + tự bật hộp thoại in ngay, không chờ server build PDF.
            window.open(`/phieuthongtinsinhvien?id=${this.route.params.id}&autoprint=1`, '_blank')
        },
        // Gác chung cho In/Tải phiếu thông tin SV: phải CÓ MSSV (phiếu in ra mà trống MSSV là phiếu hỏng;
        // file PDF cũng đặt tên/cache theo MSSV -> thiếu MSSV sẽ sinh 1 file dùng chung cho mọi hồ sơ).
        // MSSV không nhất thiết đến từ "Xác nhận hoàn tất" — có thể cấp riêng trước đó.
        canPrintApplicantInfo() {
            if (this.dataCustomer?.status == 'cancel') {
                Swal.fire({ text: 'Phiếu đã hủy — không in/tải được phiếu thông tin sinh viên.', icon: 'info', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-light-primary' } })
                return false
            }
            if (!this.dataCustomer?.studentCode) {
                Swal.fire({ text: 'Hồ sơ chưa có MSSV nên chưa in/tải được phiếu thông tin sinh viên.', icon: 'info', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-light-primary' } })
                return false
            }
            return true
        },
        async actionExportPdf() {
            if (!this.canPrintApplicantInfo()) { return }
            // Tải FILE PDF: ưu tiên file TẠO SẴN (pre-generate lúc xác nhận/Lưu phiếu/đổi hồ sơ — tải ngay,
            // mùa nhập học SV đông); chưa có file BE mới generate (~10-20s). Đổi template phiếu -> chạy
            // backend scripts/regen-applicant-pdfs.js sau khi deploy FE.
            this.popupLoading()
            let tempData = {
                id: this.route.params.id,
                studentCode: this.dataCustomer?.studentCode,
            }
            await axios.post(`/applicant/export/pdf/applicantinfo`,tempData)
            .then(({ data }) => {
                Swal.close()
                window.open(data.filePath,'_blank');
            })
            .catch(({ response }) => {
                console.log('err', response)
            });
        },
        actionDownload() {
            this.popupLoading() //nén ZIP file đính kèm mất vài giây — trước đây bấm xong im lặng tưởng không chạy
            axios.get(`/admission/register/download/${this.dataCustomer?.admissionRegistration.idAdReg}`,
            {responseType: 'arraybuffer', }) //arraybuffer, blob
            .then((response) => {
            //BE trả 200 + JSON {message} khi KHÔNG có gì để nén (hồ sơ chưa có file đính kèm/phiếu) —
            //lưu JSON đó thành .zip là Windows báo "invalid" -> phải nhận diện và hiện message thay vì saveAs
            const ct = String(response.headers['content-type'] || '')
            if (ct.includes('application/json')) {
                let j = {} as any
                try { j = JSON.parse(new TextDecoder('utf-8').decode(response.data)) } catch (e) { /* */ }
                Swal.fire({ text: j.message || 'Hồ sơ chưa có file để tải.', icon: 'info', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
                return
            }
            const blob = new Blob([response.data], {
                type: 'application/octet-stream'
            })
            const url = URL.createObjectURL(blob)
            //header content-disposition có thể THIẾU (CORS không expose) -> đừng .split trên undefined (crash câm rơi vào catch)
            const cd = String(response.headers['content-disposition'] || '').split('"')
            const fileName = cd.length > 1 ? cd[1] : `ho-so-${this.dataCustomer?.admissionRegistration?.profileCode || ''}.zip`
            saveAs(url, fileName)
            Swal.close()
            }).catch((err) => {
                //response lỗi ở dạng arraybuffer -> decode mới đọc được errorMessage của BE (vd hồ sơ không có file đính kèm)
                let msg = 'Không tải được hồ sơ.'
                try {
                    const j = JSON.parse(new TextDecoder('utf-8').decode(err?.response?.data))
                    msg = j.errorMessage || j.message || msg
                } catch (e) { /* giữ message mặc định */ }
                Swal.fire({ text: msg, icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
            })
        },
        async getReceipt(applicantid,studentCode?: string) {
            if(studentCode) {
                await axios.get(`/receipt/?receipttype=pre-receipt,bc-receipt&studentcode=${studentCode}`)
                .then(({ data }) => {
                    if(data && data.length !=0) {
                        let totalPreReceipt = 0 as any
                        let paidBy = 0 as any
                        data.forEach((item:any) => {
                            if(item.journaltype == 'Deposit') {
                                totalPreReceipt += Number(item.paymentConfirmation.paid)
                            }
                            else if(item.journaltype == 'Tuition Fee') {
                                paidBy += Number(item.paymentConfirmation.paid)
                                if(!this.paidByStatus.includes(item.paymentMethod)) {
                                    this.paidByStatus.push(item.paymentMethod)
                                }
                                this.paidByIssuedDate = moment(item.issuedDate).format('DD/MM/YYYY')
                            }
                        })
                        this.paidBy = paidBy
                        // data = data.pop()
                        data[0].totalPreReceipt = totalPreReceipt
                        this.dataPreReceipt = data[0]
                        // console.log('this.paidBy',this.paidBy)
                        // console.log('this.dataPreReceipt',this.dataPreReceipt)
                    }
                    
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
            }

            
        },
    },
    async created() {
        await this.getData(this.route.params.id)
        emitter.on("checkExpiredPromotion", (data: any) => {
            this.expiredPromotion = data
        });
        // Deep-link #phieutiepnhan (từ tab Hồ sơ nhập học của chi tiết ứng viên): tự mở tab "Phiếu tiếp nhận hồ sơ"
        if (window.location.hash === '#phieutiepnhan') {
            setTimeout(() => {
                const link = document.querySelector('a[href="#kt_customer_view_personal_tab3"]') as HTMLElement
                link && link.click()
            }, 300)
        }
    },
    setup() {
        const route = useRoute()
        const dataPreReceipt = ref<any>({})
        const expiredPromotion = ref(false)
        const statusReceipt = {
            "bank_transfers": {
                label: "Chuyển khoản",
                state: "primary",
            },
            "atm_card": {
                label: "ATM/VISA/MASTERCARD",
                state: "primary",
            },
            "Cash": {
                label: "Tiền mặt",
                state: "primary",
            },
            "none": {
                label: "",
                state: "info",
            },
        }
        const paidBy = ref(0)
        const paidByStatus = ref<any>([])
        const paidByIssuedDate = ref('')
        const dataReceipt = ref<any>(null)
        
        
        const statusTag = [
            {
            code: 'completed',
            label: "Chờ xác thực",
            state: "warning",
        },{
            code: 'confirmed',
            label: "Hoàn tất",
            state: "success",
        },{
            code: 'processing',
            label: "Chưa hoàn tất",
            state: "danger",
        },{
            code: 'cancel',
            label: "Đã hủy",
            state: "danger",
        }
        ]
        const isEdit = ref(true)
        const dataCustomer = ref<any>(null as any);
        // Phiếu đang hoạt động của SV (chỉ tra khi phiếu đang xem đã hủy — banner dẫn đường)
        const activeApplicantId = ref<any>(null);
        // Tab Xác nhận ưu đãi/HB: gom ĐỦ mọi khoản ưu đãi ĐÃ LƯU (hiển thị-only, không tính lại tiền):
        // orderDetails.promotion (KM chính) + promotionMulti[] (đóng nhiều kỳ/theo kỳ) + promotionAddition[]
        // + freeTuitionRegistration: promotionvip/vippro (đóng phí sớm), promotion/promotionExtend (kèm HB), siblings
        const promotionLines = computed(() => {
            const c: any = dataCustomer.value; if (!c) return [];
            const num = (v: any) => { const n = Number(v); return isNaN(n) ? 0 : n; };
            const out: any[] = [];
            const od: any = c.orderDetails || {};
            if (od.promotion) out.push({ name: od.promotion.promotionName || od.promotion.name, amount: num(od.promotion.amount ?? od.promotion.valueAmount), percent: od.promotion.type == 'percent' ? od.promotion.value : null });
            (Array.isArray(od.promotionMulti) ? od.promotionMulti : []).forEach((p: any) => out.push({ name: p.name, amount: num(p.amount ?? p.valueAmount ?? p.value) }));
            (Array.isArray(od.promotionAddition) ? od.promotionAddition : []).forEach((p: any) => out.push({ name: p.name || p.description, amount: num(p.amount ?? p.valueAmount ?? p.value) }));
            const ftr: any[] = Array.isArray(c.freeTuitionRegistration) ? c.freeTuitionRegistration : [];
            ftr.forEach((i: any) => {
                if (i.registrationType == 'promotionvip' && i.promotionvip) out.push({ name: i.promotionvip.name, amount: num(i.promotionvip.value) });
                if (i.registrationType == 'promotionvippro' && i.promotionvippro) out.push({ name: i.promotionvippro.name, amount: num(i.promotionvippro.value), percent: i.promotionvippro.percent || null });
                if (i.registrationType == 'promotion' && i.promotion) out.push({ name: i.promotion.promotionName || i.promotion.name, amount: num(i.promotion.amount ?? i.promotion.value) });
                if (i.registrationType == 'promotionExtend' && Array.isArray(i.promotionExtend)) i.promotionExtend.forEach((p: any) => out.push({ name: p.name || p.description, amount: num(p.amount ?? p.value) }));
                if (i.registrationType == 'siblings' && i.siblings) out.push({ name: 'Giảm anh/chị/em ruột', amount: num(i.siblings.amount) });
            });
            // lọc dòng rỗng + khử trùng lặp (phòng cùng 1 KM lưu ở 2 nơi)
            const seen = new Set();
            return out.filter((p: any) => {
                if (!p.name || (!p.amount && !p.percent)) return false;
                const k = `${p.name}|${p.amount}`;
                if (seen.has(k)) return false;
                seen.add(k);
                return true;
            });
        });
        const promotionLinesTotal = computed(() => promotionLines.value.reduce((s: number, p: any) => s + (p.amount || 0), 0));
        const checkNumber = computed(() => {
            let totalPreReceipt = dataPreReceipt.value.totalPreReceipt || 0
            // console.log('totalPreReceipt',totalPreReceipt)
            let a = (+total.value - (+paidBy.value + +totalPreReceipt)) != 0
            // console.log('a',a)
            return a
        });

        const total = computed(() => {
            let total = 0
            // console.log('dataCustomer.value',dataCustomer.value)
            if(dataCustomer.value) {
                if(dataCustomer.value.orderDetails) {
                    dataCustomer.value.orderDetails.items?.forEach((item: any) => {
                        if(item.type != 'deposit' && item.type != 'tuitionpaid') {
                            let amount = +item.value
                            if(item.type != 'tuition') {
                                amount = -amount
                            }
                            console.log('amount',amount)
                            total += amount
                        }
                    })//.reduce((a, b) => a + +b.total, 0)
                }
                // console.log('dataPreReceipt',dataPreReceipt)
                // total += (dataPreReceipt.value.totalPreReceipt||0)
            }
            // console.log('tatoa',total)
            return total
        });
        return {
            statusReceipt,
            statusTag,
            promotionLines,
            promotionLinesTotal,
            dataCustomer,
            activeApplicantId,
            isEdit,
            Permission,
            paidBy,
            paidByStatus,
            paidByIssuedDate,
            expiredPromotion,
            dataReceipt,
            total,
            dataPreReceipt,
            checkNumber,
            route
        };
    },
});
